import { useState } from 'react'
import {
  Box,
  Flex,
  Stack,
  Text
} from '@chakra-ui/react'
import { LoadingSpinier } from 'common/Loading'
import { StyledTabs } from './styled'

import { getMatrixClient } from '../Matrix/clientStore'
import { ContactList } from './ContactsList'

export const MessengerChatUI = ({
  directRooms,
  page,
  setOpenRoomId,
  setPage
}) => {
  const [backgroundColorUsed, setBackgroundColorUsed] = useState('#757575')

  const getRoomCreatedTs = (roomItem) => (
    roomItem
      ?.currentState
      .getStateEvents('m.room.create', '')
      ?.getTs() ?? 0
  )

  const handleChatList = () => {
    const client = getMatrixClient()

    const rooms = page === 'contacts' ? directRooms : []

    return rooms
      .map((room) => {
        const roomItem = client?.getRoom(room?.roomId)

        const events = roomItem?.getLiveTimeline().getEvents() ?? []
        const lastMsgEvent = [...events].reverse().find(
          (e) => e.getType() === 'm.room.message' && !e.isRedacted()
        )

        const lastMessageTime = lastMsgEvent?.getTs() ?? null

        return {
          room,
          lastMessage: lastMsgEvent?.getContent()?.body ?? '',
          lastMessageTime,
          sortTs: lastMessageTime ?? getRoomCreatedTs(roomItem)
        }
      })
      .sort((a, b) => b.sortTs - a.sortTs)
      .map(({
        room,
        lastMessage,
        lastMessageTime
      }) => (
        <ContactList
          room={{
            roomId: room?.roomId,
            name: room?.name,
            avatarUrl: room?.avatarUrl
          }}
          lastMessage={lastMessage}
          lastMessageTime={lastMessageTime}
          setOpenRoomId={setOpenRoomId}
        />
      ))
  }

  const handleChangePage = (pageItem) => {
    setPage(pageItem) // 'contacts' or 'groups'
    if (pageItem === 'contacts') {
      setBackgroundColorUsed('#757575')
    } else if (pageItem === 'groups') {
      setBackgroundColorUsed('#585858')
    } else if (pageItem === 'businesses') {
      setBackgroundColorUsed('#c3c3c3')
    }
  }

  return getMatrixClient()
    ? (
      <Box backgroundColor="white" height="100%" width="100%">
        <Stack
          className="messenger-chat-wrapper"
          height="100%"
          width="100%"
          position="relative"
          overflow="hidden"
          gap="0"
          // backgroundColor="#757575"
        >
          <Stack height="25px" alignItems="center" justifyContent="center" marginTop="10px">
            <Flex direction="row" width="100%" fontSize="16px" justifyContent="space-between">
              <StyledTabs $bg="#757575" onClick={() => handleChangePage('contacts')}>
                <Text color="white">
                  Contacts
                </Text>
              </StyledTabs>
              <StyledTabs $bg="#585858" onClick={() => handleChangePage('groups')}>
                <Text color="white">
                  Groups
                </Text>
              </StyledTabs>
              <StyledTabs $bg="#c3c3c3" onClick={() => handleChangePage('businesses')}>
                <Text color="black">
                  Businesses
                </Text>
              </StyledTabs>
            </Flex>
          </Stack>
          <Stack backgroundColor={backgroundColorUsed} height="calc(100% - 40px)" overflowY="auto" padding="10px" gap="10px">
            {handleChatList()}
          </Stack>
        </Stack>
      </Box>
    )
    : (<LoadingSpinier />)
}
